// bkExportDataSlice.ts - אותו דבר, רק שיניתי את ה-message הדיפולטי
import { createSlice } from "@reduxjs/toolkit";
import { BookkeepingExportDataDTO } from "../../models/BKExportData.model";
import { BKExportDataThunks } from "../thunks/bkExportDataThunks";

interface BKExportDataState {
  loading: boolean;
  error: string | null;
  success: boolean;
  message: string;
  bkExportData: BookkeepingExportDataDTO | null;
}

const initialState: BKExportDataState = {
  loading: false,
  error: null,
  success: false,
  message: "",
  bkExportData: null,
};

const bkExportDataSlice = createSlice({
  name: "bkExportData",
  initialState,
  reducers: {
    clearMessages: (state) => {
      state.error = null;
      state.success = false;
      state.message = "";
    },
    resetBKExportDataState: (state) => {
      Object.assign(state, initialState);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(BKExportDataThunks.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
        state.message = "";
      })
      .addCase(BKExportDataThunks.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        // ה-message מגיע מה-thunk (שם הקובץ שהורד)
        state.message = action.payload.message || "הקובץ יוצא בהצלחה";
        state.bkExportData = action.payload.data;
        state.error = null;
      })
      .addCase(BKExportDataThunks.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload || "שגיאה בייצוא לחשבשבת";
        state.message = "";
      });
  },
});

export const { clearMessages, resetBKExportDataState } =
  bkExportDataSlice.actions;
export default bkExportDataSlice.reducer;
